import { injectable } from "@launchtray/tsyringe-async";
import { Bindable, nameof, NotifyProperty } from "bindable-data";
import { SaveModel } from "./SaveModel";

@injectable()
export class TutorialModel extends Bindable {
    public readonly moleShootTutorialComplete: NotifyProperty<boolean>;
    constructor(private readonly saveModel: SaveModel) {
        super();
        this.moleShootTutorialComplete = new NotifyProperty(this, nameof(this, "moleShootTutorialComplete"), this.saveModel.read("TutorialModel", "moleShootTutorialComplete", "boolean", false));
    }

    public completeMoleShootTutorial(): void {
        this.moleShootTutorialComplete.setValue(true);
        this.saveModel.write("TutorialModel", "moleShootTutorialComplete", "boolean", this.moleShootTutorialComplete.value);
    }
}